import React from 'react'

export function SeparatorSection(props) {
    return <div className="origo-lisere" style={{height:props.size, backgroundColor:props.color}} ></div>
}

export default SeparatorSection;